module.exports = __webpack_public_path__ + "assets/img/8.a126f9e0.png";